import M from "antd/lib/modal/Modal";
import { color } from "src/styles/globals";
import styled from "styled-components";
import { Title as sundayTitle, Body as sundayBody } from "sunday-component";
import CommonButton from "./Button";

export const Title = styled(sundayTitle).attrs({ level: 5 })`
  margin-top: 4px;
  text-align: center;
  color: ${color.charcoal10};
`;
export const Body = styled(sundayBody).attrs({ level: 7 })`
  margin-top: 8px;
  color: ${color.charcoal10};
`;

export const BodyCenter = styled(Body).attrs({ level: 7 })`
  text-align: center;
`;

export const Button = styled(CommonButton).attrs({
  fullWidth: true,
})`
  margin-top: 16px;
`;

export const Modal = styled(M)`
  .ant-modal-body {
    padding: 0px;
  }

  .ant-modal-content {
    border-radius: 12px;
  }
  .ant-modal-header {
    border-radius: 12px;
  }
`;

export const CustomizationDialogContainer = styled.div`
  padding: 16px;
`;
